import { navLinks } from '@config';

import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { IconLogo } from '@components/icons';
import Menu from './menu';

const FloatingDock = styled.header`
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: var(--transition);
  background: rgba(26, 26, 36, 0.4);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 42, 42, 0.5);
  border-radius: 50px;
  padding: 5px 20px;
  box-shadow: 0 10px 30px -15px rgba(0, 0, 0, 0.5), 0 0 25px rgba(255, 42, 42, 0.3);

  @media (max-width: 900px) {
    bottom: 20px;
    width: 90%;
    left: 5%;
    transform: none;
    border-radius: 30px;
    padding: 4px 12px;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    bottom: 10px;
    padding: 2px 15px;
    border-radius: 20px;
  }
`;

const DockNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1400px;
  padding: 5px 20px;

  @media (max-width: 900px) {
    padding: 6px 10px;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    animation: logo-float 4s ease-in-out infinite;

    a {
      width: 40px;
      height: 40px;
      color: var(--green);
      transition: all 0.22s cubic-bezier(0.645, 0.045, 0.355, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.03);
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 4px;

      @media (max-height: 500px) and (orientation: landscape) {
        width: 32px;
        height: 32px;
        padding: 2px;
      }

      @media (hover: hover) {
        &:hover {
          transform: scale(1.1) rotate(8deg);
          filter: drop-shadow(0 0 10px var(--green));
          background: rgba(255, 255, 255, 0.08);
        }
      }

      &.touch-active {
        transform: scale(1.1) rotate(8deg);
        filter: drop-shadow(0 0 10px var(--green));
        background: rgba(255, 255, 255, 0.08);
      }

      &::after {
        content: '';
        position: absolute;
        top: -50%;
        left: -150%;
        width: 50%;
        height: 200%;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.25) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: rotate(30deg);
        animation: shine 3s infinite;
      }

      svg {
        width: 100%;
        height: 100%;
        user-select: none;
        position: relative;
        z-index: 1;
      }
    }
  }

  @keyframes logo-float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-4px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  @keyframes shine {
    0% {
      left: -150%;
    }
    100% {
      left: 150%;
    }
  }

  ol {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    align-items: center;

    li {
      margin: 0 15px;

      a {
        display: inline-block;
        padding: 6px 12px;
        border-radius: 20px;
        border: 1px solid transparent;
        color: var(--light-slate);
        font-family: var(--font-sans);
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.5px;
        transition: var(--transition);

        &:hover {
          color: var(--green);
          border-color: rgba(255, 42, 42, 0.6);
          transform: scale(1.15);
        }
      }
    }

    @media (max-width: 900px) {
      display: none;
    }
  }

  .resume-button {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 14px;
    padding: 10px 24px;
    background: rgba(40, 10, 10, 0.6);
    backdrop-filter: blur(5px);
    color: #ffffff !important;
    border: none;
    letter-spacing: 0.5px;
    transition: var(--transition);
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    /* Left Bracket */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 100%;
      border: 2px solid var(--green);
      border-right: none;
      transition: var(--transition);
    }

    /* Right Bracket */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 6px;
      height: 100%;
      border: 2px solid var(--green);
      border-left: none;
      transition: var(--transition);
    }

    &:focus {
      outline: none;
      background: rgba(40, 10, 10, 0.6);
      color: #ffffff !important;

      &::before,
      &::after {
        width: 6px;
        box-shadow: none;
      }
    }

    @media (hover: hover) {
      &:hover {
        background: rgba(255, 42, 42, 0.1);
        color: #ff2a2a !important;

        &::before,
        &::after {
          width: 10px;
          box-shadow: 0 0 5px var(--green);
        }
      }
    }

    &:active,
    &.touch-active {
      background: rgba(255, 42, 42, 0.1);
      color: #ff2a2a !important;

      &::before,
      &::after {
        width: 10px;
        box-shadow: 0 0 5px var(--green);
      }
    }

    @media (max-width: 900px) {
      display: none;
    }
  }
`;

const Nav = () => {
  const Logo = (
    <div className="logo" tabIndex="-1">
      <Link to="/" aria-label="home" data-touch-duration="800">
        <IconLogo />
      </Link>
    </div>
  );

  return (
    <FloatingDock>
      <DockNav>
        {Logo}
        <ol>
          {navLinks &&
            navLinks.map(({ url, name }, i) => (
              <li key={i}>
                <Link to={url}>{name}</Link>
              </li>
            ))}
        </ol>
        <a
          className="resume-button"
          href="/Noor-Ul-Baseer's_Resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Resume
        </a>
        <Menu />
      </DockNav>
    </FloatingDock>
  );
};

export default Nav;
